import { Pagination } from "@silversea-ssc/ui-components-react";
import React, { useCallback } from "react";
import { usePagination } from "react-instantsearch";
import { useMediaQuery } from "react-responsive";

type Props = {
  onClick?: () => void;
};
const AlgoliaPagination: React.FC<Props> = ({ onClick }) => {
  const { nbPages, currentRefinement, refine } = usePagination();
  const isDesktop = useMediaQuery({ query: "(min-width: 1024px)" });

  const _onClick = useCallback(
    (page: number) => {
      refine(page - 1);
      if (onClick) onClick();
    },
    [refine, onClick]
  );

  if (nbPages <= 1) return null;

  return (
    <Pagination
      currentPage={currentRefinement + 1}
      onClick={_onClick}
      totalPages={nbPages}
      length={isDesktop ? 7 : 5}
    />
  );
};

export default AlgoliaPagination;
